import { H3HexagonLayer } from 'deck.gl';
import {
  PARAMETROS_ADITIVOS,
  brilloPulso,
  celdasConTiempos,
  celdasConAnillos,
} from './pulso';

// Pulso de ignicion viajando hacia afuera desde la celda elegida. Dorado
// brillante en la cresta, ambar que se apaga rapido hacia la cola. Es el
// color del primer orden (acceso desde la vivienda); los ecos de segundo
// orden (destinos de trabajo, capas/segundoOrden.js) van en rojo.
//
// Usa tiempos de viaje reales cuando isocronas.json tiene una entrada para
// origenH3 (calculados con r5py sobre la red OSM en preparar_ttm_hex.py): la
// forma del pulso sigue la red de calles, no un circulo perfecto. Si esos
// datos no estan disponibles para esta celda (dependencia opcional), cae a
// una cascada topologica por anillos H3 como aproximacion estilizada.
const DORADO_CRESTA = [255, 236, 176];
const AMBAR_COLA = [230, 138, 24];
const OPACIDAD_MAXIMA = 235;
const ANCHO_ESTELA_MINUTOS = 3; // minutos de cola tras el frente, con datos reales
const ANCHO_ESTELA_ANILLOS = 2.2; // anillos de cola, con la cascada topologica de respaldo
const TRANSPARENTE = [0, 0, 0, 0];

function interpolaColorOnda(brillo) {
  const t = Math.max(0, Math.min(1, brillo));
  return [
    Math.round(AMBAR_COLA[0] + (DORADO_CRESTA[0] - AMBAR_COLA[0]) * t),
    Math.round(AMBAR_COLA[1] + (DORADO_CRESTA[1] - AMBAR_COLA[1]) * t),
    Math.round(AMBAR_COLA[2] + (DORADO_CRESTA[2] - AMBAR_COLA[2]) * t),
  ];
}

// Celdas de la onda, fijas por origen; se memoiza en App. La animacion vive
// en el accessor de color de la capa, no en el data.
export function preparaOnda({ origenH3, isocronas, grilla, maxAnillos = 10 }) {
  if (origenH3 === null || origenH3 === undefined) return null;
  const pares = isocronas && isocronas[origenH3];
  if (pares) return { celdas: celdasConTiempos(pares, grilla), real: true };
  return { celdas: celdasConAnillos(origenH3, maxAnillos), real: false };
}

export function construyeCapaOnda({ onda, t, maxMinutos = 30, maxAnillos = 10 }) {
  if (!onda || onda.celdas.length === 0) return null;

  const frenteAnillos = (t / maxMinutos) * maxAnillos;
  const brilloDe = onda.real
    ? (d) => brilloPulso(t - d.minutos, ANCHO_ESTELA_MINUTOS)
    : (d) => brilloPulso(frenteAnillos - d.anillo, ANCHO_ESTELA_ANILLOS);

  return new H3HexagonLayer({
    id: 'onda',
    data: onda.celdas,
    pickable: false,
    extruded: false,
    filled: true,
    stroked: false,
    highPrecision: 'auto',
    parameters: PARAMETROS_ADITIVOS,
    getHexagon: (d) => d.h3,
    getFillColor: (d) => {
      const brillo = brilloDe(d);
      if (brillo === null) return TRANSPARENTE;
      return [...interpolaColorOnda(brillo), Math.round(brillo * OPACIDAD_MAXIMA)];
    },
    updateTriggers: {
      getFillColor: [t],
    },
  });
}
